import React from 'react'
import CollegeFootball from 'src/components/page/college-football'
import { teamIds } from 'src/constants/personalizationIds'
export default (props) => (
  <CollegeFootball
    {...props}
    team="Texas Longhorns"
    hasGenericVideo={true}
    teamId={teamIds['Texas Longhorns']}
    poster="https://assets-imgx.fubo.tv/marketing/lp/images/posters/CFB/Longhorns.png"
  />
)
